export default __webpack_public_path__ + "static/media/promo_catalog_sample.2e37c4d3.png";